import { useContext } from 'react';
import {
  ApplicationUpsaleContext,
  ApplicationUpsaleContextType,
} from '@/hooks/providers/useApplicationUpsaleProvider';

const useApplicationUpsale = (): ApplicationUpsaleContextType =>
  useContext(ApplicationUpsaleContext);

export default useApplicationUpsale;
